<template>
  <div class="app-navbar-actions"> 
    <language-dropdown class="app-navbar-actions__item app-navbar-actions__item--language"/>
    <profile-dropdown class="app-navbar-actions__item app-navbar-actions__item--profile">
      <span v-if="!userName.includes('undefined')">{{userName}}</span>
    </profile-dropdown>
  </div>
</template>

<script>
import ProfileDropdown from './dropdowns/ProfileDropdown'
import NotificationDropdown from './dropdowns/NotificationDropdown'
import LanguageDropdown from './dropdowns/LanguageDropdown'
import ColorDropdown from './dropdowns/color-dropdown/ColorDropdown'
export default {
  name: 'app-navbar-actions',

  components: {
    ColorDropdown,
    NotificationDropdown,
    ProfileDropdown,
    LanguageDropdown
  },

  props: {
    userName: {
      type: String,
      default: '',
    },
    isTopBar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isTopBarProxy: {
      get () {
        return this.isTopBar
      },
      set (isTopBar) {
        this.$emit('update:isTopBar', isTopBar)
      },
    },
  },
}
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }
  
  &__item {
    padding: 0;
    margin-left: 1.25rem;
    margin-right: 1.25rem;
    
    svg {
      height: 24px;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &--profile {
      display: flex;
      justify-content: center;
      margin: auto 0 auto 1rem;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 768px) {
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }

      &--profile {
        position: absolute;
        right: 0.75rem;
        top: 1.25rem;
        height: fit-content;
        margin: auto;
      }
       &--language {
        position: absolute;
        right: 2.7rem;
        bottom: -1.3rem;
        top: 1.25rem;
        height: fit-content;
        margin: auto;
      }
    }
  }
}
</style>
